import '../App.css';
import rodolfo from '../images/rodolfo.png'

function Rodolfo () {
    return(
        <img className="Rodolfo" src={rodolfo} alt="rodolfo"/>
    )
}

export default Rodolfo;